<template>
    <f7-page
        name="My Pulse"
        class="onboardingBg withHalfBgRev"
    >
        <f7-navbar
            large
            title-large="My Pulse"
            no-hairline
            no-shadow
            large-transparent
            inner-class="onboardingBg"
        >
            <f7-nav-left>
                <f7-link
                    back
                    icon="ion-ios-arrow-left"
                />
            </f7-nav-left>
            <f7-nav-title>My Pulse</f7-nav-title>
            <f7-nav-right />
        </f7-navbar>

        <f7-block>
            <p style="font-size: 18px; line-height: 25px">
                This is your weekly Pulse. You’ll be able to look at this space and see how your sexuality has evolved over time - an important measure of health and happiness.
                <!-- Using Coral to take your pulse weekly allows you to see how you’re feeling sexually over time - an important measure for health and life satisfaction. -->
            </p>
            <div
                v-if="isLoaded && trackerData.timeForTracker"
                class="ansButtons"
            >
                <f7-button
                    v-if="trackerData.timeForTracker"
                    color="red"
                    fill
                    round
                    href="#"
                    @click="goToInPopup(`/units/285`)"
                >Take your pulse now</f7-button>

            </div>
        </f7-block>
        <div class="whiteBg">
            <div class="timeline maxWidth">
                <!-- Timeline item  
                <div class="timeline-item">
                    <div class="timeline-item-date">21 <small>DEC</small></div>
                    <div class="timeline-item-divider"/>
                    <div class="timeline-item-content">Plain text item</div>
                </div>
                Timeline item with inner 
                <div class="timeline-item">
                    <div class="timeline-item-date">22 <small>DEC</small></div>
                    <div class="timeline-item-divider"/>
                    <div class="timeline-item-content">
                        <div class="timeline-item-inner">Another text goes here</div>
                    </div>
                </div> -->
                <!-- Timeline item with special timeline elements -->
                <div class="timeline-item">
                    <div class="timeline-item-date" />
                    <div class="timeline-item-divider" />
                    <div class="timeline-item-content">
                        <div class="timeline-item-title date">{{ getDate(new Date(), 'day') }} {{ getDate(new Date(), 'month') }}</div>
                        <!-- <div class="timeline-item-time">{{ getDate(new Date(), 'time') }} </div> -->
                        <div class="timeline-item-title grayed">{{ trackerData.countSinceLast }} unit{{ trackerData.countSinceLast > 1 ? 's' : '' }} since last pulse</div>
                    </div>
                </div>
                <template v-for="(item, i) in graphDetails">
                    <div
                        v-if="item && item[0]"
                        :key="`gdata-${i}`"
                        class="timeline-item"
                    >
                        <div class="timeline-item-date" />
                        <div class="timeline-item-divider" />
                        <div class="timeline-item-content">
                            <div class="timeline-item-title date">{{ getDate(item[0].createdAt, 'day') }} {{ getDate(item[0].createdAt, 'month') }}</div>
                            <!-- <div class="timeline-item-time">{{ getDate(item.createdAt, 'time') }}</div> -->
                            <div class="timeline-item-title">
                                <i
                                    v-if="item[0].choiceInt === 0"
                                    style="padding-top: 1px; padding-left: 1px"
                                    class="weather ion-ios-sunny-outline"
                                />
                                <i
                                    v-else-if="item[0].choiceInt === 1"
                                    style="padding-top: 1px; padding-left: 3px"
                                    class="weather ion-ios-partlysunny-outline"
                                />
                                <i
                                    v-else-if="item[0].choiceInt === 2"
                                    style=" padding-left: 1px"
                                    class="weather ion-ios-cloudy-outline"
                                />
                                <i
                                    v-else-if="item[0].choiceInt === 3"
                                    style="padding-top: 1px; padding-left: 1px"
                                    class="weather ion-ios-rainy-outline"
                                />
                                <i
                                    v-else-if="item[0].choiceInt === 7"
                                    class="weather ion-ios-thunderstorm-outline"
                                />
                                <i
                                    v-else-if="item[0].choiceInt === 4"
                                    style="padding-top: 1px; padding-left: 1px"
                                    class="weather ion-ios-snowy"
                                />
                            </div>
                            <div
                                v-if="item[0] && item[0].choiceText && !isFalsyOrHasWhiteSpaces(item[0].choiceText.split('====')[0])"
                                class="timeline-item-title"
                                v-html="$sanitize(item[0].choiceText.split('====')[0].replace(/,/g, '. ')+'.')"
                            />
                            <div
                                v-if="item[0] && item[0].choiceText && !isFalsyOrHasWhiteSpaces(item[0].choiceText.split('====')[1])"
                                class="timeline-bubble"
                                v-html="$sanitize(item[0].choiceText.split('====')[1])"
                            />
                            <div
                                v-else-if="item[0] && i === 0"
                                style="padding-top: 10px"
                            >

                                <f7-button
                                    style="width: 160px;"
                                    outline
                                    round
                                    @click="goToInPopup(`/units/285`)"
                                >
                                    <i
                                        class="icon ion-plus"
                                        style="line-height: 8px;"
                                    />
                                    &nbsp;Add a note</f7-button>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="item && item[0]"
                        :key="`gdata-${i}-2`"
                        class="timeline-item"
                    >
                        <div class="timeline-item-date" />
                        <div class="timeline-item-divider" />
                        <div class="timeline-item-content">
                            <div class="timeline-item-title date">{{ getDate(item[0].createdAt, 'day') }} {{ getDate(item[0].createdAt, 'month') }}</div>
                            <!-- <div class="timeline-item-time">{{ getDate(new Date(), 'time') }} </div> -->
                            <div class="timeline-item-title grayed">{{ item[0].unitsCompleted }} unit{{ item[0].unitsCompleted > 1 ? 's' : '' }} completed</div>
                        </div>
                    </div>
                </template>

                <div class="timeline-item">
                    <div class="timeline-item-date" />
                    <div class="timeline-item-divider" />
                    <div class="timeline-item-content">
                        <div class="timeline-item-title date">{{ getDate(user.createdAt, 'day') }} {{ getDate(user.createdAt, 'month') }}</div>

                        <!-- <div class="timeline-item-time">{{ getDate(user.createdAt, 'time') }} </div> -->
                        <div class="timeline-item-title">You joined Coral</div>
                    </div>
                </div>
            </div>
        </div>
    </f7-page>
</template>

<script>
import moment from 'moment';
import sanitizeHTML from 'sanitize-html';
// Dynamically rendering arbitrary HTML can be very dangerous
Vue.prototype.$sanitize = sanitizeHTML;

export default {
    store: ['api', 'user', 'trackerData', 'timeOfLast'],
    data () {
        return {
            isLoaded: false,
            timeForTracker: false,
            graphData: [],
            graphDetails: []
        };
    },
    created: function () {
        this.getGraphData(1);
        this.$events.fire('pulse-get', () => {
            this.isLoaded = true;
        });
        this.$events.on('pulse_completed', () => {
            f7.views['main'].router.refreshPage();
        });
    },
    mounted: function () { },
    methods: {
        isFalsyOrHasWhiteSpaces: (text) => {
            // whenever the sring has zero or more empty space Or undefined
            // we return falsy
            // note that ideally undefined should be handle on the comment returning 
            // the choiceText
            return (text === 'undefined') ?
                true:
                /^\s*$/g.test(text);

        },
        goToInPopup: function (url) {
            f7.views['popup'].router.navigate(url, {
                animate: false,
                clearPreviousHistory: true
            });
            if (!pgap) window.history.pushState(null, "", '/web' + url);
            setTimeout(() => {
                f7.popup.get('#popup').open();
            }, 250);
            // f7.statusbar.setTextColor('white');
        },
        timeTill: function () {
            return moment(this.timeOfLast)
                .add(7, 'd')
                .fromNow();
        },
        getDate: function (date, format) {
            if (format === 'day') {
                format = 'DD';
            }
            if (format === 'time') {
                format = 'HH:mm';
            }
            if (format === 'month') {
                format = 'MMM';
            }
            return moment(date).format(format);
        },
        getGraphData: function (id) {
            this.$http.get(`${this.api}/results/graphData/${id}`).then(
                response => {
                    this.graphData = response.body.graph.reverse();
                    // for (let i = 0; i < response.body.details.length; i++) {
                    //     if (!response.body.details[i] && i !== response.body.details.length - 1) response.body.details[i] = response.body.details[i + 1];
                    // }
                    // console.log(response.body.details)
                    this.graphDetails = response.body.details.reverse();
                },
                () => {
                    console.error('Could not fetch tracker');
                }
            );
        }
    }
};
</script>
<style lang="less" scoped>
@import '../css/colors.less';
.whiteBg {
    background: white;
    padding-top: 50px;
    min-height: 80vh;
}
.theme-dark {
    .whiteBg {
        background: #1c1c1d;
    }
}
.timeline-bubble {
    background: @darkBackground;
    font-family: AndesLight;
    color: #888;
    margin: 5px 0px;
    border-radius: 10px;
    padding: 12px;
    font-size: 16px;
    line-height: 18px;
}
.center {
    text-align: center;
    width: 100%;
}
.weather {
    position: absolute;
    left: -44px;
    top: -5px;
    background: @coral;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    border: 2px solid white;
    color: white;
    font-size: 50px;
    line-height: 10px;
    text-align: center;
    padding: 0px;
    &:before {
        line-height: 0.7 !important;
    }
}
.theme-dark {
    .weather {
        border: 2px solid #1c1c1d;
    }
}
.timeline-item {
    padding-bottom: 80px;
}
.timeline-item-date,
.timeline-item-time {
    font-family: AndesLight;
    font-size: 10px;
    color: @darkGray;
    line-height: 12px;
    font-weight: bold;
}
.timeline-item-date {
    line-height: 15px;
}
.timeline-item-title {
    font-family: Editor-Bold;
    color: #000;
    font-size: 18px;
    &.date {
        font-family: AndesLight;
        font-size: 12px;
        margin-top: -4px;
        font-weight: bold;
        line-height: 22px;
        text-transform: uppercase;
        color: @darkGray;
    }
}
.theme-dark {
    .timeline-item-title {
        color: #fff;
    }
}
.grayed {
    color: #ccc !important;
}
.timeline-item-subtitle {
    font-family: AndesLight;
    font-size: 12px;
    color: @darkGray;
    line-height: 13px;
    text-transform: none;
}
</style>
